import {
  Box,
  Flex,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  Image,
} from "@chakra-ui/react";
import CloseIconBlack from "../../../assets/images/booking/x-circle.svg";
import { formatDateDb } from "../../../utils/tools";

const DetailAction = ({ isOpen, onClose, defaultValues }) => {
  const filteredEmployeeObjects = defaultValues?.employeeObjects?.filter(
    (emp) => emp?._id?.toString() !== defaultValues?.employee?._id?.toString()
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        // h={"625px"}
        w={"100%"}
        maxW={"625px"}
        overflowY={"auto"}
        sx={{
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            width: "4px",
            borderRadius: "50px",
            background: "var(--color-background)",
          },
          "&::-moz-scrollbar": {
            width: "4px",
          },
          "&::-moz-scrollbar-thumb": {
            width: "4px",
            borderRadius: "50px",
            background: "var(--color-background)",
          },
        }}
      >
        <Flex flexDirection={"column"}>
          <Flex
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"10px"}
            padding={"25px 24px"}
            borderBottom={"1px solid var(--bg-line-employee)"}
          >
            <Text
              color="var(--color-header-employee)"
              fontSize={"18px"}
              fontWeight={"600"}
            >
              Chi tiết cảnh báo
            </Text>
            <Box cursor={"pointer"} onClick={onClose}>
              <Image src={CloseIconBlack} />
            </Box>
          </Flex>
          <Box flex={1} w={"545px"} m={"24px auto"}>
            Ngày{" "}
            {defaultValues?.employee?.createdAt
              ? formatDateDb(defaultValues?.employee?.createdAt)
              : ""}{" "}
            {defaultValues?.employee?.action
              ? defaultValues?.employee?.action?.toLowerCase()
              : ""}{" "}
            thiết bị{" "}
            {defaultValues?.deviceInfo?.modelName ||
              defaultValues?.deviceInfo?.deviceName ||
              ""}{" "}
            giống tài khoản{" "}
            {filteredEmployeeObjects?.length > 0 &&
              filteredEmployeeObjects?.map((item, index) => {
                if (
                  item?._id?.toString() !==
                  defaultValues?.employee?._id?.toString()
                ) {
                  return `${item?.fullName} (${item?.code})${
                    index > 0 ? ", " : ""
                  }`;
                } else {
                  return "";
                }
              })}
          </Box>
        </Flex>
      </ModalContent>
    </Modal>
  );
};

export default DetailAction;
